/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { next } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { AuthzEngines } from '@square/authz-engines';
import { PolicyProtectedAction } from '@square/ember-multipass-components/models/squareup/authz_engines/authz_engines_service';
import { TwoFactorVerificationSourceScope_TwoFactorVerificationSource as TwoFactorVerificationSource } from '@square/ember-multipass-components/models/squareup/multipass/common';
export let TwoFactorScaFlow = /*#__PURE__*/function (TwoFactorScaFlow) {
  TwoFactorScaFlow["LOADING"] = "LOADING";
  TwoFactorScaFlow["PASSWORD"] = "PASSWORD";
  TwoFactorScaFlow["TWO_FACTOR"] = "TWO_FACTOR";
  TwoFactorScaFlow["LOCKED_OUT"] = "LOCKED_OUT";
  TwoFactorScaFlow["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
  return TwoFactorScaFlow;
}({});
export let TwoFactorScaError = /*#__PURE__*/function (TwoFactorScaError) {
  TwoFactorScaError["ATTEMPT_NOT_ALLOWED"] = "ATTEMPT_NOT_ALLOWED";
  return TwoFactorScaError;
}({});
let TwoFactorScaBaseComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _dec3 = service('ember-multipass-config'), _class = class TwoFactorScaBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get twoFactorVerificationSource() {
    return TwoFactorVerificationSource.SCA_VERIFICATION;
  }
  get isLoadingView() {
    return this.flow === this.flows.LOADING;
  }
  get isPasswordView() {
    return this.flow === this.flows.PASSWORD;
  }
  get isTwoFactorView() {
    return this.flow === this.flows.TWO_FACTOR;
  }
  get isLockedOutView() {
    return this.flow === this.flows.LOCKED_OUT;
  }
  get isVerificationFailedView() {
    return this.flow === this.flows.VERIFICATION_FAILED;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _initializerDefineProperty(this, "multipassConfig", _descriptor5, this);
    _defineProperty(this, "flows", TwoFactorScaFlow);
    _initializerDefineProperty(this, "flow", _descriptor6, this);
    _initializerDefineProperty(this, "password", _descriptor7, this);
    _initializerDefineProperty(this, "error", _descriptor8, this);
    _defineProperty(this, "checkScaVerificationAttempt", async () => {
      const {
        allow
      } = await AuthzEngines.allow({
        env: this.multipassConfig.environment,
        extraHeaders: {
          'X-Csrf-Token': this.multipassfeClient.getCsrfToken()
        },
        data: {
          action: PolicyProtectedAction.SCA_VERIFICATION_ATTEMPT
        }
      });
      if (!allow) {
        return Promise.reject(new Error(TwoFactorScaError.ATTEMPT_NOT_ALLOWED));
      }
    });
    _defineProperty(this, "handlePasswordSubmit", password => {
      this.password = password;
      next(() => {
        this.flow = this.flows.TWO_FACTOR;
      });
    });
    _defineProperty(this, "handleTotpSubmit", async data => {
      try {
        data.password = this.password;
        await this.multipassfeClient.upgradeSessionMultipleFactors(data);
      } catch (e) {
        try {
          await this.checkScaVerificationAttempt();
        } catch (e) {
          if (e.message === TwoFactorScaError.ATTEMPT_NOT_ALLOWED) {
            this.flow = this.flows.LOCKED_OUT;
            return Promise.reject(e);
          }
        }
        this.flow = this.flows.VERIFICATION_FAILED;
        return Promise.reject(e);
      }
      // Success, TwoFactor::Upgrade::Base will finish SCA verification flow by running @finish
    });
    _defineProperty(this, "handleVerificationFailedContinue", () => {
      this.password = '';
      this.flow = this.flows.PASSWORD;
    });
    this.initFlow();
  }
  handleUnknownInitError() {
    this.marketToasts.critical(this.intl.t(this.tPrefix + 'generic_errors.other.unknown'));
  }
  async initFlow() {
    try {
      const results = await Promise.allSettled([this.checkScaVerificationAttempt(), this.multipassfeClient.listTwoFactor(this.twoFactorVerificationSource), this.multipassfeClient.status(),
      // Add 500ms buffer to allow loading dialog to open.
      // Without this, when the network is blazingly fast `dismissModal` might not be able to find
      // the dialog element when it's moving to the next screen, causing the loading dialog to stay open.
      new Promise(resolve => setTimeout(resolve, 500))]);
      results.forEach(result => {
        if (result.status === 'rejected') {
          throw result.reason;
        }
      });
      this.flow = this.flows.PASSWORD;
    } catch (e) {
      this.logger.error('Error initializing two factor sca', e.message);
      if (e instanceof Error && e.message === TwoFactorScaError.ATTEMPT_NOT_ALLOWED) {
        this.flow = this.flows.LOCKED_OUT;
        return;
      }
      this.handleUnknownInitError();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.LOADING;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "password", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TwoFactorScaBaseComponent as default };